import { render, staticRenderFns } from "./hazardEquipmentLayoutDetail.vue?vue&type=template&id=3977fc57"
import script from "./hazardEquipmentLayoutDetail.vue?vue&type=script&lang=js"
export * from "./hazardEquipmentLayoutDetail.vue?vue&type=script&lang=js"
import style0 from "./hazardEquipmentLayoutDetail.vue?vue&type=style&index=0&id=3977fc57&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3977fc57')) {
      api.createRecord('3977fc57', component.options)
    } else {
      api.reload('3977fc57', component.options)
    }
    module.hot.accept("./hazardEquipmentLayoutDetail.vue?vue&type=template&id=3977fc57", function () {
      api.rerender('3977fc57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/hazardEquipment/hazardEquipmentLayoutDetail.vue"
export default component.exports